import { FaUser,FaSchool} from 'react-icons/fa';import {BiBasketball} from 'react-icons/bi'
import {BsFillMicFill,BsBrowserChrome} from 'react-icons/bs'
import {GiGraduateCap} from 'react-icons/gi'
import {SiGraphql} from 'react-icons/si'


export const questions = [
    {
      question: 'What i am?',
      answer: [
        { point: ' I am Himanshu Choudhary, graduated in ECE, who is passionate about coding and development.', icon: FaUser, color: 'purple' },
      ],
    },
    {
      question: 'What I do?',
      answer: [
        { point: 'I am interested in Web development, Machine Learning and Problem solving.', icon: BsBrowserChrome, color: 'red' },
        { point: 'Most time of my day is spent solving DSA and CP problems and making some cool stuff with code.', icon: SiGraphql, color: 'blue' },
      ],
    },
    {
      question: 'What is my Educational Background?',
      answer: [
        { point: 'Graduated in ECE from National Institute of Technology, Kurukshetra in 2023.', icon: GiGraduateCap, color: 'green' },
        { point: 'I have completed my high school from Candlewick Public School, Jaipur.', icon: FaSchool, color: 'crimson' },
      ],
    },
    {
      question: 'What I do apart from Coding?',
      answer: [
        { point: 'I play Basketball and a huge fan of NBA.', icon: BiBasketball, color: 'orange' },
        { point: 'You can ping me for any discussion about Sports.', icon: BsFillMicFill, color: 'blue' },
      ],
    },
  ];